import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * The redirects that keep the pre-COL-464 URLs working.
 *
 * They live here rather than inline in `App.tsx` so the part with actual logic
 * — rebuilding the destination by hand, and what that carries across — can be
 * tested without pulling the whole app's module graph into the test.
 */

/** Redirects an old static route to its new root, preserving query/hash. */
export function RouteRedirect({ to }: { to: string }) {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}${location.hash}`} replace />;
}

/** Old /properties/:location deep links → /rooms/:location, preserving query/hash. */
export function PropertiesLocationRedirect() {
  const { location: locationParam } = useParams<{ location: string }>();
  const location = useLocation();
  return (
    <Navigate
      to={`/rooms/${locationParam ?? ""}${location.search}${location.hash}`}
      replace
    />
  );
}
